import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconWallet1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"wallet-1"} maskId="square-filled-radius-0-stroke-1-IconWallet1"><path fillRule="evenodd" clipRule="evenodd" d="M2 4H22V20H2V4ZM3 5V7H21V5H3ZM21 8H3V10L9 10V13H15V10L21 10V8Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconWallet1;
